import React from "react";

import styled from "styled-components";

import { APP_NAME } from "Constants/documentationUrls";
import logo from "Vendor_resources/images/logo-auth.svg";

const LogoImg = styled.img`
  z-index: 2;
  height: 40px;
  position: relative;
`;

const Logo = () => {
  return <LogoImg src={logo} alt={APP_NAME} />;
};

export default Logo;
